import React from "react";
import styled from "styled-components";

import { COLOR_BLACK } from "@static/COLORS";

const StyledIcon = styled.svg`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width = "20px" }) => width};
  height: ${({ height = "20px" }) => height};
  fill: ${({ fill = COLOR_BLACK }) => fill};
  transform: ${({ isRotated }) => (isRotated ? "rotate(-180deg)" : "none")};
  cursor: ${({ isCursor, disabled }) =>
    disabled ? "not-allowed" : isCursor ? "pointer" : "auto"};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const Icon = ({
  children,
  width,
  height,
  fill,
  style,
  isRotated,
  isCursor = false,
  onClick = () => undefined,
  disabled = false,
}) => {
  return (
    <StyledIcon
      disabled={disabled}
      isCursor={isCursor}
      style={{ ...style }}
      width={width}
      height={height}
      fill={fill}
      onClick={disabled ? undefined : onClick}
      isRotated={isRotated}
    >
      {children}
    </StyledIcon>
  );
};
